import React, { Component } from 'react';
import axios from 'axios';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { getProducts, getCartProducts, addProduct, removeProduct, updateProductQuantity, fetchData, filterProducts, getOffers, get_user_lang } from '../../repository';
import Mattresspage from './mattress-page/Mattresspage';
import Middleware from './middle-ware/Middleware';
import products from './products/Products';
import { throws } from 'assert';
import Products from './products/Products';
import Pillowpage from './pilow-page/pillowpage';

// import { map, tail, times, uniq, _ } from 'lodash';


const cookies = new Cookies();

let csrftoken = '';
let userlang = '';
let mattress_quantity = '';
let mattress_size= '';
let mattress_comfort = '';
let site_page_category: '';
let childProducts = [];
let search, params, requested_size;


class Cart extends Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        // const { cookies } = props;
        this.state = {
            false_positive: false,
            quantity: '',
            comfort: '',
            size: '',
            add_to_cart: false,
            default_product_price: [],
            original_price: '',
            subtotal: 0,
            product_page_category: '',
            perform_tasket: true,
            page_url_path:'',
            basket: {
                id: 0,
                owner: '',
                lines: '',
                url:'',
                total_excl_tax: '',
                total_excl_tax_excl_discounts: '',
                total_incl_tax: '',
                total_incl_tax_excl_discounts: '',
                total_tax: '',
                offers: [],
                is_tax_known: true,
                voucher_discount: [],
            },
            basket_lines: [],
            num_of_products: 0,
            products: [],
            products_detail:[],
            temp_products_detail:[],
            parent_category: '',
            parent_products: [],
            parent_products_meta_data: [],
            children_products: [],
            children_products_detail: [],
            product_price: [],
            product_sku: [],
            product_availability: [],
            product_options: [],
            new_current_product: {
                id: '',
                parent_id: '',
            },
            default_products: [],
            child_products_urls: [],
            child_products: [],
            current_product: {
                id: '',
                url: '',
                title: '',
                category: '',
                parent_id: '',
                recommended_products: [],
                options: [],
                upc: '',
                sku: '',
                sku_url: '',
                price: Object.values({
                    'currency': 'CAD',
                    'excl_tax': '699.00',
                    'incl_tax': '699.00',
                    'tax': '0.00',
                }),
                price_url: '',
                availability: [],
                availability_url: '',
                size: "",
                comfort: "",
            },
            offers: [],
            vouchers: [],
            offers_set: false,
            is_discounted_set: false,
            data_loaded: false,
            product_id_set: 0,
            userlang: ''
        };

        // this.openClose = this.openClose.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {


        if (this.state.parent_products_meta_data !== prevState.parent_products_meta_data) {
            // console.log(`Now Proceed to get child product Urls`);
            // console.log(this.state.parent_products);
            /* this.getChildProductUrls(); */
        }

        if ( (this.state.child_products_urls !== prevState.child_products_urls) ) {
            /* Retrieve child products */
            // console.log(`Now Proceed to get child products`);
            // console.log(this.state.child_products_urls);

            // /* this.ChildProductDetail(); */

        }

        // if ( (this.state.child_products !== prevState.child_products) ) {
        //     /* Retrieve child products */
        //     console.log(`Now Proceed to set default current product`);
        //     console.log(this.state.child_products);
        //     // this.setCurrentProduct()
        // }

        if (this.state.children_products_detail !== prevState.children_products_detail) {
            /* Retrieve child products */
            // console.log(`Now Proceed to initialize basket and set product price for customer`);
            this.init_cart_basket();
        }

        // if (this.state.is_discounted_set === false && this.state.offers_set === false){
            if (this.state.subtotal !== undefined ){
            // console.log('trying to update subtotal', this.state);
                // this.is_product_discounted();
            }

        // if (this.state !== this.prevState){
        //     console.log('Did Upate');
        //     console.log(this.state);
        // }

        /* For Debug Purposes ONly */
        // if (this.state.page_url_path !== prevState.page_url_path){
        //     console.log(`Current URL Path: ${this.state.page_url_path}`);
        // }

        /* End of Debug Output*/

    }

    componentDidMount() {
        // this.get_cbs_language_cookie();
        this.get_current_language();

        this.get_offers();

        this.setState({
            page_url_path: window.location.pathname
        });

        if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
          csrftoken = window.document.getElementById('tracker-id').value;
        }

        const set_lang = window.document.getElementsByClassName("user-lang")[0];
        set_lang.addEventListener("click", this.set_user_language);


        site_page_category = document.getElementsByClassName('hero hero--chill')[0].dataset.productCategory;

        this.setState({
            product_page_category: site_page_category,
        });

        // getProducts()

        // .then((parent_products) => {
        //     this.setState({
        //         parent_products: parent_products
        //     })
        //     // console.log(`Products: `,parent_products)
        //     return parent_products;
        // })

        // .then( (parent_products) => {
        //     // this.getProductUrls(parent_products);
        //     let i=0;
        //     for (i=0; i < parent_products.length; i++) {
        //         let item_category;
        //         if (parent_products.title === 'Essential Medium') {
        //             item_category = 'cocoon-essential';
        //         } else {
        //             item_category = 'cocoon-classic';
        //         }
        //         let attributes = {
        //             category: item_category,
        //             parent_id: parent_products.id
        //         }

        //         let metadata = this.state.parent_products_meta_data.concat(attributes);
        //         this.setState({
        //             parent_products_meta_data: metadata
        //         });
        //     }
        // })

        // .then( () => {
        //     this.setState({
        //         product_page_category: site_page_category,
        //     })
        // })

        // document.addEventListener('load', this.testChildproducts());

        this.init_app=this.init_app.bind(this);
        this.calc_subtotal_qty=this.calc_subtotal_qty.bind(this);
        // this.init_app();

        // const csrftoken = cookies.get('csrftoken');
        // console.log(`CSRF TOKEN ${csrftoken}`);
    }

    init_app () {

        // console.log(`+++++++++++++++++++++++++++++++++++ Initializing App +++++++++++++++++++++++++++++++++++++`);
        // console.log(this.state);
        // this.calc_subtotal_qty();
        // alert("Hello")

    }

    test_app = () => {
        alert("Hello world")
    }

    set_user_language = (e) => {
        e.preventDefault();
        // console.log('Now Send form');
        const form = window.document.getElementById('userlang');
        form.submit();
    }

    get_cbs_language_cookie = () => {
        get_user_lang().then( (data) => {
            // console.log('User language is ... ',data);
            if (data.userlang !== undefined) {
                userlang = data.userlang;
                this.setState({
                    userlang
                });
            }
        })


        // if (cookies.get('cbs_language') === 'fr') {
        //     console.log('CBS_LANGUAGE is ... ', cookies.get('cbs_language') );
        //     userlang = cookies.get('cbs_language');
        //     this.setState({
        //         userlang
        //     });
        // }else {
        //     userlang = 'en'; // try to get cookie cbs_language
        //     this.setState({
        //         userlang
        //     });
        // }
    }

    get_current_language = () => {
      const mylang = document.getElementsByName("next");
      const lang = mylang[0].value;
      if (lang.includes("fr")) {
        userlang = "en";
      } else {
        userlang = "fr";
      }

      // console.log("Current Language is ... ", userlang);

      this.setState({
        userlang
      });
    };

    testChildproducts = () => {
        // console.log(`*******************  Parent Products **************`);
        // console.log(this.state.parent_products);

        // console.log(`*******************  Parent Products Metadata **************`);
        // console.log(this.state.parent_products_meta_data);

        // console.log(`*******************  Child Products urls **************`);
        // console.log(this.state.child_products_urls);

        // console.log(`*******************  Child Products **************`);
        // console.log(this.state.child_products);

        // console.log(`*******************  Current Product **************`);
        // console.log(this.state.current_product);

        // console.log(`*******************  Cart Basket **************`);
        // console.log(this.state.basket);


    }

    setCurrentProduct = (data)=> {
        // console.log(`Setting Current Product Selected`);
        // console.log(`Getting Default Product for Category: ${this.state.product_page_category}`);

        // const results = res.filter(item => item.upc === '')
        let pdata = this.state.child_products;
        let default_product = "";

        if (this.state.product_page_category === "cocoon-classic") {
            default_product = data.filter(item => item.category === 'cocoon-classic');
            default_product = default_product.filter(item => item.default === true);
            //item => item.default === true,
            // default_product = pdata.filter(item => item.default === true);
            // console.log(newdata);
        }else if (this.state.product_page_category === "cocoon-essential") {
            default_product = data.filter(item => item.category === 'cocoon-essential');
            default_product = default_product.filter(item => item.default === true);
        }

        // console.log(`Current Default Product`);
        // console.log( default_product.price );

        // this.setState({
        //     current_product: default_product
        // }, function (default_product) {
        //     console.log("updated state:", this.state);
        // });

        return default_product;

    }


    /* Cart Opertations Init */
    init_cart_basket = () => {
        getCartProducts().then((basketData) => {
            this.setState(
                {basket:{
                    id: basketData.id,
                    owner: basketData.owner,
                    curremcy: basketData.curremcy,
                    lines: basketData.lines,
                    url: basketData.url,
                    total_excl_tax: basketData.total_excl_tax,
                    total_excl_tax_excl_discounts: basketData.total_excl_tax_excl_discounts,
                    total_incl_tax: basketData.total_incl_tax,
                    total_incl_tax_excl_discounts: basketData.total_incl_tax_excl_discounts,
                    total_tax: basketData.total_tax,
                    offers: basketData.offer_discounts,
                    voucher_discount: basketData.voucher_discounts,
                    is_tax_known: basketData.is_tax_known,
                }}
            )});
    }

    update_current_product = (mattress_comfort, mattress_size) => {
        // console.log(`Here I am ... Mattress Comfort: ${mattress_comfort} Mattress Size: ${mattress_size}`)
        this.new_current_product(mattress_comfort, mattress_size);
    }

    new_current_product = (mattress_comfort, mattress_size) => {
        console.log(`+_+_+__+_+_+_+_+_+_+_+_+_+_+_++_ Updating Current Product Cart.js +_+_+_+_+_+_+_+_+_+_+_+_+_`)
        console.log(`Size: ${mattress_size}`);
        console.log(`Size document.getElementById`, document.getElementById('mattress_size').value);
        console.log(`Comfort: ${mattress_comfort}`);
        console.log(`Current State: `,this.state);
        // let pdata = this.state.child_products;
        let default_product = "";
        const product_page_category = this.state.product_page_category
        const metadata = this.get_product_meta_data(product_page_category);
        const product_options = this.state.product_options;
        // console.log(pdata);
        console.log(`Product Options`, product_options);

        if (product_page_category === "cocoon-classic" || product_page_category === "cocoon-essential") {



            default_product = product_options.filter(item => item.category === product_page_category);
            // console.log(default_product);
            default_product = default_product.filter(item => item.comfort === mattress_comfort);
            // console.log(default_product);
            default_product = default_product.filter(item => item.size === mattress_size);
            //item => item.default === true,
            // default_product = pdata.filter(item => item.default === true);
            // console.log(newdata);
        }else if (product_page_category === "sealy-premium" || product_page_category === "sealy-performance" || product_page_category === "sealy-essential") {
            // do nothing for now
        }

        console.log(`<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< Neew Current Default Product >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>`);
        console.log(default_product);

        const current_product = {id: default_product[0].id, parent_id: metadata[0].parent_id};

        this.setState({
            new_current_product: current_product

        },() => {
            // console.log("updated state:", this.state.current_product);
            // this.calc_subtotal_qty(this.state);
        });

        // if (this.state.is_discounted_set === false)
        //         this.is_product_discounted();
        // console.log(`Current Default Product`);
        // console.log(default_product);

    }

    get_product_meta_data = (category) => {
        const data=this.state.parent_products_meta_data;
        const attributes = data.filter(item => item.category === category);
        return attributes;
    }


    calc_subtotal_qty(_State, discount) {
        console.log(`+_+_+__+_+_+_+_+_+_+_+_+_+_+_++_ Updating Price Subtotal +_+_+_+_+_+_+_+_+_+_+_+_+_`)
        // console.log(this.state);
        // console.log( JSON.stringify(_State.current_product))
        const mattress_quantity = document.getElementById('quantity').value;
        const mattress_size= document.getElementById('mattress_size').value;
        const mattress_comfort = document.getElementById('comfort').value;
        const current_product_id = this.state.new_current_product.id;
        const data = this.state.product_price;
        const current_product =data.filter(item => item.id === current_product_id);
        console.log(`Price `, current_product);
        let subtotal;


        if (typeof(current_product.price) !== undefined || current_product.price !== null) {
            // console.log('Not Undefined or Not Null');
            subtotal = ( parseFloat(mattress_quantity) * parseFloat(current_product.price.excl_tax) ).toFixed(2);
        } else {
            // console.log('Undefined or Null')
            subtotal="-";
        }
        // console.log(`subtotal qty ${subtotal}`);

        this.setState({
                subtotal: subtotal,
                original_price: parseFloat(current_product.price.excl_tax).toFixed(2)
        });

    }

    get_current_product_orig_price = () => {
        // console.log(`//////////////////////////////////////// Orginal Price //////////////////////////////////////////////////`);
        // console.log(this.state.original_price);

        // return parseFloat(this.state.current_product[0].price.excl_tax).toFixed(2);
    }


    getProductUrls = (data) => {
        let i=0;
        let urls = [];
        for (i=0; i < data.length; i++) {
            urls.push(data[i].url);
            this.parentProductMetaData(data[i].url);
        }
        // console.log(`Product Urls: `);
        // console.log(urls);
        this.getChildProductUrls(urls);
        return urls;
    }
    parseParentData = (data) => {
        let item_category;
        if (data.title === 'Essential Medium') {
            item_category = 'cocoon-essential';
        } else {
            item_category = 'cocoon-classic';
        }
        const items = data.children;
        return {
            category: item_category,
            children: items,
            parent_id: data.id
        }



    }

    getChildProductUrls = () => {

        const urls = this.state.parent_products;
        let results = [];
        let childUrls = [];
        for (let [key, pvalue] of Object.entries(urls)) {
            results[key] = fetchData( pvalue.url )
        }

        axios.all(results)
            .then(axios.spread(function (resultsA, resultsB) {
                // Both requests are now complete
                // console.log(`Processing Child Urls`);
                // console.log(resultsA);
                // console.log(resultsB);

                let item_categoryB;
                let item_categoryA;

                if (resultsA.title === 'Essential Medium') {
                    item_categoryA = 'cocoon-essential';
                }

                if (resultsB.title === 'Cocoon Classic') {
                    item_categoryB = 'cocoon-classic';
                }

                for (let [key, value] of Object.entries(resultsA.children)) {
                    // console.log(`${key}: ${value}`);
                    childUrls = childUrls.concat({'url':value.url, 'parent_id':resultsA.id, 'category':item_categoryA});
                }

                for (let [key, value] of Object.entries(resultsB.children)) {
                    // console.log(`${key}: ${value}`);
                    childUrls = childUrls.concat({'url':value.url, 'parent_id':resultsB.id, 'category':item_categoryB});
                }

                // return childUrls;

            }))

            .then( (data) =>{
                this.setState({
                    child_products_urls: childUrls
                });
            })

    }

    ChildProductDetail = () => {
        let i=0;
        let category = "";
        let parent_id = "";
        let products = [];
        let product;
        let buildData = [];
        let mattress_size;
        let child_products = [];
        let mattress_comfort;
        let results = [];
        const urls = this.state.child_products_urls;

        for (let [key, pvalue] of Object.entries(urls)) {
            results[key] = fetchData( pvalue.url )
        }

        axios.all(results)
            .then(axios.spread(function (results_1, results_2, results_3, results_4, results_5, results_6, results_7, results_8, results_9, results_10, results_11, results_12, results_13, results_14, results_15) {
                // console.log(`Processing Child Products`);
                products = products.concat(results_1);
                products = products.concat(results_2);
                products = products.concat(results_3);
                products = products.concat(results_4);
                products = products.concat(results_5);
                products = products.concat(results_6);
                products = products.concat(results_7);
                products = products.concat(results_8);
                products = products.concat(results_9);
                products = products.concat(results_10);
                products = products.concat(results_11);
                products = products.concat(results_12);
                products = products.concat(results_13);
                products = products.concat(results_14);
                products = products.concat(results_15);

                return products;

            }))

            .then( (data) => {
                let misc_urls = []
                for (let [key, value] of Object.entries(data) ) {

                    product = {
                        sku_url: value.stockrecords,
                        price_url: value.price,
                        availability_url: value.availability,
                    }
                    misc_urls = misc_urls.concat(product);
                }

                return misc_urls;
            })

            .then( (data) =>{
                // update sku urls
                // console.log(`Updating Sku's, Prices, and Stock Availability`);
                // console.log(data);
                let Sresults;
                let Aresults;
                let Presults;
                let stockrecords = [];
                let prices = [];
                let availability = [];

                const stockrecordsRes = this.fetch_stock_records(data);
                const pricesRes = this.fetch_product_price(data);
                const availabilityRes = this.fetch_product_availability(data);

                axios.all(stockrecordsRes)
                    .then(axios.spread(function (results_1, results_2, results_3, results_4, results_5, results_6, results_7, results_8, results_9, results_10, results_11, results_12, results_13, results_14, results_15) {

                        // console.log(`Stock Records`);
                        stockrecords = stockrecords.concat(results_1);
                        stockrecords = stockrecords.concat(results_2);
                        stockrecords = stockrecords.concat(results_3);
                        stockrecords = stockrecords.concat(results_4);
                        stockrecords = stockrecords.concat(results_5);
                        stockrecords = stockrecords.concat(results_6);
                        stockrecords = stockrecords.concat(results_7);
                        stockrecords = stockrecords.concat(results_8);
                        stockrecords = stockrecords.concat(results_9);
                        stockrecords = stockrecords.concat(results_10);
                        stockrecords = stockrecords.concat(results_11);
                        stockrecords = stockrecords.concat(results_12);
                        stockrecords = stockrecords.concat(results_13);
                        stockrecords = stockrecords.concat(results_14);
                        stockrecords = stockrecords.concat(results_15);
                        data = data.concat(stockrecords);
                        return data;
                    }))


                axios.all(pricesRes)
                    .then(axios.spread(function (results_1, results_2, results_3, results_4, results_5, results_6, results_7, results_8, results_9, results_10, results_11, results_12, results_13, results_14, results_15) {

                        // console.log(`Product Prices`);
                        prices = prices.concat(results_1);
                        prices = prices.concat(results_2);
                        prices = prices.concat(results_3);
                        prices = prices.concat(results_4);
                        prices = prices.concat(results_5);
                        prices = prices.concat(results_6);
                        prices = prices.concat(results_7);
                        prices = prices.concat(results_8);
                        prices = prices.concat(results_9);
                        prices = prices.concat(results_10);
                        prices = prices.concat(results_11);
                        prices = prices.concat(results_12);
                        prices = prices.concat(results_13);
                        prices = prices.concat(results_14);
                        prices = prices.concat(results_15);

                        data = data.concat(prices);
                        return data;
                    }))


                axios.all(availabilityRes)
                    .then(axios.spread(function (results_1, results_2, results_3, results_4, results_5, results_6, results_7, results_8, results_9, results_10, results_11, results_12, results_13, results_14, results_15) {

                        // console.log(`Product Availability`);
                        availability = availability.concat(results_1);
                        availability = availability.concat(results_2);
                        availability = availability.concat(results_3);
                        availability = availability.concat(results_4);
                        availability = availability.concat(results_5);
                        availability = availability.concat(results_6);
                        availability = availability.concat(results_7);
                        availability = availability.concat(results_8);
                        availability = availability.concat(results_9);
                        availability = availability.concat(results_10);
                        availability = availability.concat(results_11);
                        availability = availability.concat(results_12);
                        availability = availability.concat(results_13);
                        availability = availability.concat(results_14);
                        availability = availability.concat(results_15);

                        data = data.concat(availability);
                        return data;
                    }))

                    .then( (data_availability) => {
                        // console.log(`Availability`);
                        // console.log(data_availability);

                        // for (let [key, pvalue] of Object.entries(data) ) {

                        //     data[key].availability = data_availability[key];
                        // }
                        const stockrecords = data.filter(item => item.partner_sku, item => item.price_currency);
                        const prices = data.filter(item => item.incl_tax, item => item.currency);
                        const availability = data.filter(item => item.is_available_to_buy);
                        let misc_data = []
                        misc_data = misc_data.concat(stockrecords);
                        misc_data = misc_data.concat(prices);
                        misc_data = misc_data.concat(availability);

                        // data = data_availability;
                        return misc_data;
                    })

                    .then( (data) => {
                        axios.all(results)
                            .then(axios.spread(function (results_1, results_2, results_3, results_4, results_5, results_6, results_7, results_8, results_9, results_10, results_11, results_12, results_13, results_14, results_15) {
                                // console.log(`Processing Child Products`);
                                // products = products.concat(results_1);
                                // products = products.concat(results_2);
                                // products = products.concat(results_3);
                                // products = products.concat(results_4);
                                // products = products.concat(results_5);
                                // products = products.concat(results_6);
                                // products = products.concat(results_7);
                                // products = products.concat(results_8);
                                // products = products.concat(results_9);
                                // products = products.concat(results_10);
                                // products = products.concat(results_11);
                                // products = products.concat(results_12);
                                // products = products.concat(results_13);
                                // products = products.concat(results_14);
                                // products = products.concat(results_15);

                                // return products;

                                data = data.concat(products);

                                return data;
                            }))

                            .then( (data) => {
                                const stockrecords = data.filter(item => item.partner_sku, item => item.price_currency);
                                const prices = data.filter(item => item.incl_tax, item => item.currency);
                                const availability = data.filter(item => item.is_available_to_buy);
                                const products = data.filter(item => item.title);
                                let products_essential = [];
                                let products_classic = [];
                                // console.log(`Products To be set to State`);
                                // console.log(products);
                                // console.log(`Products To be set to State - Prices`);
                                // console.log(prices);
                                // console.log(`Products To be set to State - Stock`);
                                // console.log(stockrecords);
                                // console.log(`Products To be set to State - availability`);
                                // console.log(availability);

                                for (let [key, value] of Object.entries(products) ) {
                                    // console.log(`${key}: ${value}`);
                                    if ( value.title.includes("Classic") ) {
                                        products_classic = products_classic.concat(value);
                                    }else if ( value.title.includes("Essential") ) {
                                        products_essential = products_essential.concat(value);
                                    }

                                    product = {
                                        id: value.id,
                                        url: value.url,
                                        title: value.title,
                                        category: urls[key].category,
                                        parent_id: urls[key].parent_id,
                                        recommended_products: value.recommended_products,
                                        options: value.options,
                                        upc: value.upc,
                                        sku: stockrecords[key].partner_sku,
                                        sku_url: value.stockrecords,
                                        price: prices[key],
                                        price_url: value.price,
                                        availability: availability,
                                        availability_url: value.availability,
                                        size: this.match_mattress_size(value.title),
                                        comfort: this.match_mattress_comfort(value.title),
                                        default: this.set_default_product(value.title),
                                    }

                                    child_products = child_products.concat(product);
                                    setTimeout(true, 100);
                                }

                                // console.log(`Products To be set to State - Classic`);
                                // console.log(products_classic);
                                // console.log(`Products To be set to State - Essential`);
                                // console.log(products_essential);

                                // console.log(`Products To be set to State - Final Check`);
                                // console.log(child_products);

                                return child_products;

                            })

                            .then( (data) =>{
                                // console.log(`About to set current product`);
                                // console.log(data);
                                setTimeout(true, 300);
                                let def_product = [];

                                const page_category = document.getElementsByClassName('hero hero--chill')[0].dataset.productCategory;
                                if (page_category === "cocoon-classic") {
                                    // console.log(`page Category 1: ${page_category}`);
                                    def_product = data.filter(item => item.default === true);
                                    def_product = def_product.filter(item => item.category === 'cocoon-classic');
                                    // console.log(def_product);

                                }else if (page_category === "cocoon-essential") {
                                    // console.log(`page Category 2: ${page_category}`);
                                    def_product = data.filter(item => item.default === true);
                                    def_product = def_product.filter(item => item.category === 'cocoon-essential');
                                    // console.log(def_product);
                                }

                                // console.log(`Current Default Product A`);
                                // console.log( def_product[0].price.excl_tax);
                                setTimeout(true, 100);
                                // const mattress_quantity = document.getElementById('quantity').value;
                                // const subtotal = (parseFloat(def_product[0].price.excl_tax)).toFixed(2);
                                const original_price = (parseFloat(def_product[0].price.excl_tax)).toFixed(2);
                                // console.log(subtotal)
                                this.setState({
                                    original_price: original_price,
                                    child_products: data,
                                    current_product: def_product,
                                    // subtotal: subtotal,
                                })


                            })

                    })

            })

    }

    basket_products = () => {
        return this.state.childProducts;
    }

    match_mattress_size = (title) => {
        let mattress_size = "";

        if (title.match(/King/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "King";
        }else if (title.match(/Queen/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Queen";
        }else if (title.match(/Full/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Full";
        }else if (title.match(/Twin/g) && !title.match(/XL/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Twin";
        }else if (title.match(/XL/g) && title.match(/Twin/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Twin XL";
        }
        return mattress_size;

    }

    match_mattress_comfort = (title) => {
        let comfort = "";
        if (title.match(/Soft/g)) {
            // alert("FUCK YEAH Soft Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Soft";
        }else if (title.match(/Firm/g)) {
            // alert("FUCK YEAH Firm Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Firm";
        }else if (title.match(/Medium/g)) {
            // alert("FUCK YEAH Medium Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Medium";
        }

        return comfort;

    }

    set_default_product = (title) => {

        let default_product = false;
        if (title.match(/Twin/g) && title.match(/Soft/g) && !title.match(/XL/g)) {
            default_product = true;
        }else if (title.match(/Twin/g) && title.match(/Medium/g) && !title.match(/XL/g) ) {
            default_product = true;
        }

        return default_product;
    }


    fetch_stock_records = (data) => {
        let Sresults = [];
        for (let [key, value] of Object.entries(data)) {
            Sresults[key] = fetchData( value.sku_url );
        }
        return Sresults;
    }

    fetch_product_price = (data) => {
        let Presults = [];;
        for (let [key, value] of Object.entries(data)) {
            Presults[key] = fetchData( value.price_url );
        }
        return Presults;
    }

    fetch_product_availability = (data) => {
        let Aresults = [];
        for (let [key, value] of Object.entries(data)) {
            // console.log(`${key}: ${Svalue.sku_url}`);
            Aresults[key] = fetchData( value.availability_url );
        }
        return Aresults;
    }

    getPriceSkuAvailability = (_State) => {
        // console.log(`********************  Price SKU Availability ***************`)
        // console.log(_State.child_products);
        let data = this.state.child_products
        let i=0;
        for (i=0; i < data.length; i++) {
            // console.log(`Count .... ${i}`);
            this.getProductSku(data[i].sku_url, data[i].id, i);
            this.getProductPrice(data[i].price_url, data[i].id, i);
            this.getProductAvailabiliy(data[i].availability_url, data[i].id, i);
        }

    }


    getProductSku = (url,id, itemNumber) => {
        fetchData(url).then( (response) => {
            // console.log(`Product Id: ${id} Array Position: ${itemNumber}`)
            // console.log(response[0].partner_sku)
            let child_products_sku = Object.assign({}, this.state.child_products); //creating copy of object
            child_products_sku[itemNumber].sku=response[0].partner_sku
            this.setState({child_products_sku});
        });
    }

    getProductPrice = (url,id, itemNumber) => {
        fetchData(url).then( (response) => {
            let child_products = Object.assign({}, this.state.child_products); //creating copy of object
            child_products[itemNumber].price=Object.values(response)
            this.setState({child_products});
        });
    }

    getProductAvailabiliy = (url,id, itemNumber) => {
        fetchData(url).then( (response) => {
            let child_products = Object.assign({}, this.state.child_products); //creating copy of object
            child_products[itemNumber].availability=Object.values(response)
            this.setState({child_products});
        });

    }

    getCurrentProductPrice = () => {
        const price = this.getCurrentProductPriceX(this.state);

        return price;
    }

    getCurrentProductPriceX = (_State) => {
        // console.log("hello price is here");
        // console.log(_State);
        // console.log(_State.current_product);
        return _State.current_product.price;
    }

    /* Adding Products to Cart Basket */

    process_successfule_product_add = (product_data) => {
        // console.log("One Last Check before Sending Product to Submit");
        // console.log(product_data);
        //const csrftoken = cookies.get('csrftoken');
        // console.log(`CSRFTOKEN: ${csrftoken}`);

        // if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
        //     csrftoken = window.document.getElementById('tracker-id').value;
        // }
        this.setState({
            add_to_cart: true
        })
        addProduct(product_data, csrftoken).then( (data) => {
            this.setState({
                basket: data
            })
            // console.log(`Returned Data From Api For Adding Product`, data);
            // console.log(`Now send user to Basket Page`)

            return data;
        })

        .then( (data) => {
            this.setState({
                add_to_cart: false
            })
            return data;
        })

        .then( (data) => {
            //window.Cartbasket.external_component(); // Temporarily test dynamically building mini basket
            window.basketmenuitems.get_basket_lines(data.lines); // temporarily see basket items update
            window.Cartbasket.get_cart_basket(); // temporarily see minibasket update
        })

        .then ( () => {
            // console.log(`Send Customer to Basket Page`);
            const cart_url = document.getElementsByClassName('basket-summary')[0].getAttribute('href');
            // window.open('/basket');
            window.location.href=cart_url;
        });

        // console.log(send_data);
        // .then( (response) =>{
        //     console.log(`API Response: `, response);
        // })

    }

    /* Removing Products to Cart Basket */


    // Update Cart Basket
    update_cart_basket = (data) => {

        alert('This will work for now');

    }

    get_product_info = (url) => {
        let products = this.state.child_products;
        return products;
    }

    external_component = (data) => {
        console.log(`External Component Speaking Back`);
        const msg = "Hello WOrld";
        return msg;

    }

    get_cart_basket_products = () => {
        let products = this.state.child_products;
        alert(products);
        return 'hello';
    }

    // get active discount offers  & vouchers i.e coupons
    get_offers = () => {
        // console.log(`getting offers`);
        if (this.state.offers_set === false) {
            getOffers().then( (data) => {
                // console.log(`Offers`, data);
                this.setState({
                    offers: this.state.offers.concat(data.offers),
                    // vouchers: this.state.vouchers.concat(data.vouchers),
                    offers_set: true
                })
            })
        }
    }

    is_product_discounted = () =>{
        let is_discounted = false;
        let is_discounted_voucher = false;
        let subtotal;

        // if (typeof(this.state.current_product.price) !== undefined || this.state.current_product.price !== null) {
        //     // console.log('Not Undefined or Not Null');
        //     subtotal = ( parseFloat(mattress_quantity) * parseFloat(this.state.current_product[0].price.excl_tax) ).toFixed(2);
        // } else {
        //     // console.log('Undefined or Null')
        //     subtotal="-";
        // }

        // if (requested_size !== ""){
        //     const url = new URL(window.location.href);
        //     console.log('URL', url)
        //     console.log('requested mattress size', requested_size) //i.e. Twin
        //     document.getElementById('mattress_size').value = requested_size;
        //     this.update_current_product(mattress_comfort, requested_size)
        //     console.log('new mattress size', document.getElementById('mattress_size').value)
        //     url.searchParams.delete('mattress_size');
        //     url.searchParams.append('mattress_size', '');
        //     requested_size = ''
        //     window.history.replaceState(null, null, url.href);
        //     console.log('URL 2 ', url)
        // }

        if ( this.state.current_product.length > 0 && this.state.offers_set === true && this.state.product_id_set === 0) {
            // console.log('Current product offers', this.state.offers);
            // console.log('Current product vouchers', this.state.vouchers);
            // console.log('Current product offers', this.state.offers);

            const mattress_quantity = document.getElementById('quantity').value;
            const mattress_size= document.getElementById('mattress_size').value;
            const mattress_comfort = document.getElementById('comfort').value;
            const current_product_id = this.props.new_current_product.id;
            const data = this.props.product_price;
            const current_product =data.filter(item => item.id === current_product_id);

            console.log('Current Discounted State 2', this.state)
            let product_id = this.state.current_product[0].id;
            let p_id;
            // console.log('current product id: ', product_id);
            // console.log('Offers Length', this.state.offers.length)
            let offer_products, voucher_products, offer, voucher, products;
            if (this.state.offers.length > 0) {
                // products = this.state.offers.products
                // for (let [pkey, pvalue] of Object.entries( this.state.offers )) {
                // console.log('inside offers current product id: ', product_id);
                let p_id = product_id;
                for (let i=0; i < this.state.offers.length; i++) {
                    // console.log(`Key: ${key}, Value: ${value[key]['offers'].name}`);
                    // console.log('inside offer products current product id: ', p_id);
                    let data = this.state.offers[i];
                    console.log(`Key: ${i}, Value: ${data}`);
                    for (let [key, value] of Object.entries( data )) {
                        // console.log(`Key: ${key}, Value: ${value[key]}`);
                        // console.log(`Key: ${key}, Value: ${value[key]['offers'].name}`);
                        // console.log(`Key: ${key}, Product Id: ${value[key]['product_id']}`);
                        if (value['product_id'] === product_id) {
                            is_discounted = true;
                            p_id = value['product_id']
                            offer = {
                                'name': value['offers'].name,
                                'amount': value['offers'].amount,
                                'type': value['offers'].type
                            }
                            break;
                        }
                    }

                }
                // offer_products = this.state.offers.filter(item => item.product_id === 44);
                // console.log('Current product offer products ', offer_products);
                // offer = offer_products.filter(item => item.product_id === 44);
                // console.log('Current product offer', offer);
            }
            if (this.state.vouchers.length > 0) {
                // const voucher = this.state.vouchers.filter(item => item.products.id === product_id);
                // console.log('Current product voucher length', this.state.vouchers.length);

                for (let j=0; j < this.state.vouchers.length; j++) {
                    let data = this.state.vouchers[j];
                    for (let [key, value] of Object.entries( data )) {
                        // console.log(`Key: ${key}, Value: ${value}`);
                        if (value['product_id'] === product_id) {
                            is_discounted_voucher = true;
                            p_id = value['product_id']
                            voucher = {
                                'name': value['offers'].name,
                                'amount': value['offers'].amount,
                                'type': value['offers'].type
                            }
                            break;
                        }
                    }
                }
                // for (let [key, value] of Object.entries( this.state.vouchers )) {
                //     if (value[key]['product_id'] === product_id) {
                //         // console.log(`Key: ${key}, Value: ${value[key]['offers'].name}`);
                //         is_discounted_voucher = true;
                //         voucher = {
                //             'name': value[key]['offers'].name,
                //             'amount': value[key]['offers'].amount,
                //             'type': value[key]['offers'].type
                //         }
                //     }
                // }

            }

            // console.log(`subtotal qty ${subtotal}`);

            if (is_discounted){
                // console.log('offer discounted')
                //this.calc_subtotal_qty(this.state, offer)
                subtotal = parseFloat(mattress_quantity) * parseFloat(current_product.price.excl_tax);
                if (offer.type === 'Absolute') {
                    subtotal = (subtotal - offer.amount).toFixed(2);
                }else{
                    const discount = ( (parseFloat(mattress_quantity) * parseFloat(current_product.price.excl_tax)) * parseFloat(offer.amount/100));
                    subtotal = (subtotal - discount).toFixed(2);
                }
                if (this.state.is_discounted_set === false)
                    this.setState({
                        is_discounted_set: true,
                        product_id_set: p_id,
                        subtotal: subtotal,
                        original_price: parseFloat(current_product.price.excl_tax).toFixed(2)
                    });
            }else if (is_discounted_voucher){
                // console.log('voucher discounted', voucher)
                subtotal = ( parseFloat(mattress_quantity) * parseFloat(current_product.price.excl_tax) );
                if (voucher.type === 'Absolute') {
                    subtotal = (subtotal - voucher.amount).toFixed(2);
                }else{
                    const discount = ( (parseFloat(mattress_quantity) * parseFloat(current_product.price.excl_tax)) * parseFloat(voucher.amount/100));
                    subtotal = (subtotal - discount).toFixed(2);
                }
                if (this.state.is_discounted_set === false)
                    this.setState({
                        is_discounted_set: true,
                        product_id_set: p_id,
                        subtotal: subtotal,
                        original_price: parseFloat(current_product.price.excl_tax).toFixed(2)
                    });
            }else{
                subtotal = ( parseFloat(mattress_quantity) * parseFloat(current_product.price.excl_tax) ).toFixed(2);
                if (this.state.is_discounted_set === false && this.state.product_id_set === 0)
                    // console.log(`no discount subtotal: ${subtotal}` );
                    this.setState({
                        is_discounted_set: false,
                        product_id_set: -1,
                        subtotal: subtotal,
                        original_price: (parseFloat(mattress_quantity) * parseFloat(this.state.current_product[0].price.excl_tax) ).toFixed(2)
                    });
                    // console.log(`no discount state`, this.state );
            }

        }

    }

    reset_is_discounted = () => {
        // console.log('In here ==>>>>>>>>>>>>>>>>>>>>>>>>')
        this.setState({
            is_discounted_set: false,
            product_id_set: 0
        });
    }

    set_is_discounted = (is_discounted_set, product_id_set, subtotal, original_price) => {
        // console.log('product id set', product_id_set);
        this.setState({
            is_discounted_set: is_discounted_set,
            product_id_set: product_id_set,
            subtotal: subtotal,
            original_price: original_price
        });
        // console.log('product id set state', this.state.product_id_set);
    }

    /* // initializing product data */

    init_products_details_temp = (products_detail) => {
        // console.log(`Sent in products detail`, products_detail);
        this.setState({
            temp_products_detail: this.state.temp_products_detail.concat(products_detail)
        });
    }

    init_products_details = (products_detail) => {
        // console.log(`Finalizing products detail`, products_detail);
        this.setState({
            products_detail
        });
    }

    init_products = (products) =>{
        this.setState({
            products
        });
    }

    init_product_meta = (metadata) => {
        this.setState({
            parent_products_meta_data: metadata
        });
    }

    set_product_sku = (product_sku, product_id) => {
        const data = {sku: product_sku, id: product_id}
        this.setState({
            product_sku: this.state.product_sku.concat(data)
        });
    };

    set_product_price = (product_price, product_id) => {
        // console.log(`Product Price: `, product_price);
        const data = {price: product_price, id: product_id}
        this.setState({
            product_price: this.state.product_price.concat(data)
        });
    };

    set_product_availability = (product_availability, product_id) => {
        const data = {availability: product_availability, id: product_id}
        this.setState({
            product_availability: this.state.product_availability.concat(data)
        });
    };

    set_child_products = (children_products) => {
        this.setState({
            children_products: this.state.children_products.concat(children_products)
        });
    }

    set_child_products_detail = (children_products_detail) => {
        this.setState({
            children_products_detail: this.state.children_products_detail.concat(children_products_detail)
        });
    }

    set_product_options = (options) => {
        this.setState({
            product_options: this.state.product_options.concat(options)
        });
    }

    set_default_products = (default_products) => {
        // console.log(`Setting Default product: `, default_products);
        this.setState({
            default_products
        });

    }

    set_new_current_product = (new_current_product) => {
        // console.log(`Setting New Current product: `, new_current_product);
        this.setState({
            new_current_product
        });
    }

    render() {
        // console.log(this.state.product_page_category)
        if (this.state.product_page_category === 'sealy-premium' || this.state.product_page_category === 'sealy-performance'  || this.state.product_page_category === 'sealy-essential') {
            return(
                <React.Fragment>
                    <Middleware
                        // openCloseBasketModal={this.openCloseBasketModal}
                        product={this.state.product}
                        products={this.state.products}
                        lines={this.basket_lines}
                        num_of_items={this.num_of_products}
                        // setCurrentProduct={this.setCurrentProduct}
                    />

                    <Products
                        init_products={this.init_products}
                        products={this.state.products}
                        init_products_details_temp={this.init_products_details_temp}
                        products_detail_temp={this.state.temp_products_detail}
                        init_products_details={this.init_products_details}
                        products_detail={this.state.products_detail}
                        init_product_meta={this.init_product_meta}
                        set_child_products={this.set_child_products}
                        set_child_products_detail={this.set_child_products_detail}
                        children_products_detail={this.state.children_products_detail}
                        set_product_options={this.set_product_options}
                        set_product_sku={this.set_product_sku}
                        set_product_availability={this.set_product_availability}
                        set_product_price={this.set_product_price}
                        match_mattress_size={this.match_mattress_size}
                        match_mattress_comfort={this.match_mattress_comfort}
                        default_products={this.state.default_products}
                        parent_products_meta_data={this.state.parent_products_meta_data}
                        set_default_product={this.set_default_product}
                        set_default_products={this.set_default_products}
                        new_current_product={this.state.new_current_product}
                        set_new_current_product={this.set_new_current_product}
                    />

                    <Pillowpage
                        calc_subtotal_qty={this.calc_subtotal_qty}
                        basket={this.state.basket}
                        basket_lines={this.state.basket_lines}
                        quantity={this.state.quantity}
                        subtotal={this.state.subtotal}
                        updateSubtotal={this.updateSubtotal}
                        // current_product={this.state.current_product}
                        new_current_product={this.state.new_current_product}
                        // child_products={this.state.child_products}
                        children_products_detail={this.state.children_products_detail}
                        product_price={this.state.product_price}
                        product_options={this.state.product_options}
                        products_detail={this.state.products_detail}
                        // parent_products={this.parent_products}
                        // parent_products_meta_data={this.parent_products_meta_data}
                        update_current_product={this.update_current_product}
                        getCurrentProductPrice={this.getCurrentProductPrice}
                        get_current_product_orig_price={this.get_current_product_orig_price}
                        original_price={this.state.original_price}
                        process_successfule_product_add={this.process_successfule_product_add}
                        product_page_category={this.state.product_page_category}
                        is_product_discounted={this.is_product_discounted}
                        is_discounted_set={this.state.is_discounted_set}
                        offers_set={this.state.offers_set}
                        reset_is_discounted={this.reset_is_discounted}
                        product_id_set={this.state.product_id_set}
                        userlang={this.state.userlang}
                        vouchers={this.state.vouchers}
                        offers={this.state.offers}
                        set_is_discounted={this.set_is_discounted}
                    />
                </React.Fragment>
            );
        }else {
            return(
                <React.Fragment>
                    <Middleware
                        // openCloseBasketModal={this.openCloseBasketModal}
                        product={this.state.product}
                        products={this.state.products}
                        lines={this.basket_lines}
                        num_of_items={this.num_of_products}
                        // setCurrentProduct={this.setCurrentProduct}
                    />

                    <Products
                        init_products={this.init_products}
                        products={this.state.products}
                        init_products_details_temp={this.init_products_details_temp}
                        products_detail_temp={this.state.temp_products_detail}
                        init_products_details={this.init_products_details}
                        products_detail={this.state.products_detail}
                        init_product_meta={this.init_product_meta}
                        set_child_products={this.set_child_products}
                        set_child_products_detail={this.set_child_products_detail}
                        children_products_detail={this.state.children_products_detail}
                        set_product_options={this.set_product_options}
                        set_product_sku={this.set_product_sku}
                        set_product_availability={this.set_product_availability}
                        set_product_price={this.set_product_price}
                        match_mattress_size={this.match_mattress_size}
                        match_mattress_comfort={this.match_mattress_comfort}
                        default_products={this.state.default_products}
                        parent_products_meta_data={this.state.parent_products_meta_data}
                        set_default_product={this.set_default_product}
                        set_default_products={this.set_default_products}
                        new_current_product={this.state.new_current_product}
                        set_new_current_product={this.set_new_current_product}
                    />

                    <Mattresspage
                        testChildproducts={this.testChildproducts}
                        calc_subtotal_qty={this.calc_subtotal_qty}
                        comfort={this.state.comfort}
                        basket={this.state.basket}
                        basket_lines={this.state.basket_lines}
                        size={this.state.size}
                        quantity={this.state.quantity}
                        subtotal={this.state.subtotal}
                        updateSubtotal={this.updateSubtotal}
                        // current_product={this.state.current_product}
                        new_current_product={this.state.new_current_product}
                        // child_products={this.state.child_products}
                        children_products_detail={this.state.children_products_detail}
                        product_price={this.state.product_price}
                        product_options={this.state.product_options}
                        products_detail={this.state.products_detail}
                        // parent_products={this.parent_products}
                        // parent_products_meta_data={this.parent_products_meta_data}
                        update_current_product={this.update_current_product}
                        getCurrentProductPrice={this.getCurrentProductPrice}
                        get_current_product_orig_price={this.get_current_product_orig_price}
                        original_price={this.state.original_price}
                        process_successfule_product_add={this.process_successfule_product_add}
                        product_page_category={this.state.product_page_category}
                        is_product_discounted={this.is_product_discounted}
                        is_discounted_set={this.state.is_discounted_set}
                        offers_set={this.state.offers_set}
                        reset_is_discounted={this.reset_is_discounted}
                        product_id_set={this.state.product_id_set}
                        userlang={this.state.userlang}
                        vouchers={this.state.vouchers}
                        offers={this.state.offers}
                        set_is_discounted={this.set_is_discounted}
                    />
                </React.Fragment>
            );
        }

    }

}

export default Cart;
